<!-- GoodsSwipe.vue -->
<template>
	<div id="goods-swipe" class="swipe-wrapper ui-common-swiper info-goods-swipe"
		v-bind:style="'width:' + getBannerStyle.width + 'px;height:' + getBannerStyle.height + 'px'" v-if="detailInfo">
		<div v-if="detailInfo.goodsvideo_url">
			<div class="m-btn show-btn" @click="$router.push({ name: 'HomeGoodsVideo' })">
				<span class="iconfont">&#xe6c5;</span>视频
			</div>
		</div>
		<!-- 轮播图 -->
		<mt-swipe :auto="0" class="ui-common-swiper goods-image" :prevent="false" :stop-propagation="true"
			:showIndicators="false" @change="handleChange">
			<!-- detailInfo.photos && detailInfo.photos.length > 1 -->

			<!-- <mt-swipe-item v-for="(item, index) in detailInfo.photos" v-bind:key="index"
				v-if="detailInfo.photos && detailInfo.photos.length > 0">
				<img v-bind:src="item" v-on:click="setPopupVisible(index)" /> -->
			<mt-swipe-item v-for="(item, index) in list" v-bind:key="index"
				v-if="detailInfo.photos && detailInfo.photos.length > 0">
				<img v-bind:src="item" v-on:click="setPopupVisible(index)" />
			</mt-swipe-item>

			<mt-swipe-item v-if="!detailInfo.photos || detailInfo.photos.length <= 0">
				<img src="../../../../assets/image/home/default_image_banner.png" class="product-img" />
			</mt-swipe-item>
		</mt-swipe>

	</div>
</template>

<script>
import PreviewPicture from './PreviewPicture'
import { mapState, mapMutations } from 'vuex'
export default {
	data() {
		return {
			popupVisible: false,
			index: 0,
			list: []
		}
	},
	components: {
		'v-picture': PreviewPicture
	},

	created() {
		this.$on('hide-priview-picture', value => {
			this.popupVisible = value
			this.setisPreviewPicture(value)
		})

		this.list = this.detailInfo.photos
		this.list = [this.list[0]]
	},

	computed: {
		...mapState({
			detailInfo: state => state.goodsdetail.detailInfo
		}),
		getBannerStyle: function () {
			const { width } = window.screen
			let itemWidth = width
			let itemHeight = width
			return {
				width: itemWidth,
				height: itemHeight
			}
		},
	},

	methods: {
		...mapMutations({
			setisPreviewPicture: 'setisPreviewPicture',
			setSwiperId: 'setSwiperId'
		}),

		setPopupVisible() {
			this.popupVisible = true
			this.setisPreviewPicture(true)
		},

		handleChange(index) {
			this.index = index
			this.setSwiperId(index)
		}
	}
}
</script>

<style lang="scss">
.info-goods-swipe {
	.mint-swipe-items-wrap {
		.mint-swipe-item {
			text-align: center;
			overflow: hidden;
			display: flex;
			justify-content: center;
			align-items: center;
			background: #fff;

			img {
				width: 100%;
				// height: 100%;
				// width: auto;
			}
		}
	}

	.mint-swipe-indicators {
		div.mint-swipe-indicator {
			background: #efeff4;
			opacity: 1;

			&.is-active {
				background: $primaryColor;
			}
		}
	}
}
</style>
<style scoped lang="scss">
.ui-common-swiper {
	width: 100%;
	height: 100%;
}

.swipe-wrapper {
	position: relative
}

.goods-image {
	position: absolute;
	z-index: 10;
	top: 0;
	left: 0
}

.goods-video {
	position: absolute;
	z-index: 20;
	top: 0;
	left: 0;
	background: #000
}

.m-btn {
	position: absolute;
	font-size: $h1;
}

.close-btn {
	top: .5rem;
	right: .5rem;
	z-index: 30
}

.show-btn {
	bottom: .5rem;
	left: .5rem;
	z-index: 15;
	height: 1.5rem;
	line-height: 1.5rem;
	border-radius: 1.5rem;
	background: $primaryColor;
	color: #fff;
	font-size: $subFontSize;
	padding: 0 .5rem;
}
</style>
